import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {
  ReactiveBase,
  SingleList,
  ReactiveList,
  ReactiveComponent,
  SelectedFilters
} from '@appbaseio/reactivesearch'
import ESSearch from 'components/ESSearch'
import { TrackingHOC, OptionsHOC } from 'hocs'
import { updateTitle } from '../Breadcrumbs/actions'
import { getParam } from '../../helpers/parameters'
import { buildQuery } from './helpers'
import Result from 'components/ESSearch/Result'
import { pipe, sanitizeHTML } from 'helpers/utils'
import resultProcessor from './resultProcessor'
import { getCustomer } from 'helpers'
import * as KEYS from '../../constants/keys'

const Search = ({ location, updateTitle, createEvent, getOption }) => {
  const searchQuery = location.query.q
  const customer = getCustomer()

  const [reactiveSearchProps, setReactiveSearchProps] = useState({
    app: customer.toLowerCase(),
    url: null,
    headers: null
  })

  useEffect(() => {
    updateTitle(searchQuery)
  }, [searchQuery])

  useEffect(() => {
    ;(async () => {
      const token = localStorage.getItem(KEYS.JWT_TOKEN)
      const careassistApiUrl = await getParam('careassistApiUrl')

      setReactiveSearchProps({
        app: customer.toLowerCase(),
        url: `${careassistApiUrl}/search`,
        headers: { Authorization: `Bearer ${token}` }
      })
    })()
  }, [])

  const trackClick = (url) => {
    createEvent({
      category: 'search',
      data: { action: 'success', search_term: searchQuery, link_to: url }
    })
  }

  const handleResultRender = (result) => {
    const item = pipe(
      resultProcessor.addUrl(),
      resultProcessor.addTitle(),
      resultProcessor.addDescription()
    )(result)

    return <Result item={item} onClick={trackClick} key={item._id} />
  }

  const typeLabel = getOption('search.typeLabel', 'Type')
  const manufacLabel = getOption('search.manufacturerLabel', 'Manufacturer')
  const modelLabel = getOption('search.modelLabel', 'Model')

  const filters = (
    <div>
      <ReactiveComponent
        componentId="CustomQuery"
        customQuery={() => buildQuery(searchQuery)}
      />

      <SingleList
        componentId={typeLabel}
        dataField="phone_type"
        title={typeLabel}
        showSearch={false}
        react={{ and: ['CustomQuery', modelLabel, manufacLabel] }}
        className="filter"
      />
      <SingleList
        componentId={manufacLabel}
        dataField="manufacturer"
        title={manufacLabel}
        showSearch={false}
        react={{ and: ['CustomQuery', modelLabel, typeLabel] }}
        className="filter"
      />

      <SingleList
        componentId={modelLabel}
        dataField="model"
        title={modelLabel}
        react={{ and: ['CustomQuery', manufacLabel, typeLabel] }}
        className="filter"
        renderItem={(label, count) => (
          <span>
            <span dangerouslySetInnerHTML={{ __html: sanitizeHTML(label) }} />
            <span>{count}</span>
          </span>
        )}
      />
    </div>
  )

  const results = (
    <div>
      <SelectedFilters />
      <ReactiveList
        componentId="SearchResult"
        dataField="name"
        renderItem={handleResultRender}
        renderResultStats={(stats) => (
          <p style={{ fontSize: 12 }}>{stats.numberOfResults} results</p>
        )}
        react={{ and: ['CustomQuery', manufacLabel, modelLabel, typeLabel] }}
      />
    </div>
  )

  const { app, url, headers } = reactiveSearchProps

  if (!url) {
    return null
  }

  return (
    <ReactiveBase app={app} url={url} headers={headers}>
      <ESSearch filters={filters} results={results} searchQuery={searchQuery} />
    </ReactiveBase>
  )
}

const mapDispatchToProps = (dispatch) => ({
  updateTitle: (title) => dispatch(updateTitle(title))
})

export default connect(
  null,
  mapDispatchToProps
)(TrackingHOC(OptionsHOC(Search)))
